import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import getters from './getters'
import tagsView from './modules/tagsView'
import permission from './modules/permission'

import state from './exam/state'
import mutations from './exam/mutations'
import actions from './exam/actions'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    tagsView,
    permission
  },
  getters,
  state,
  mutations,
  actions
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js